document.addEventListener("DOMContentLoaded", () => {
  const cfg = window.QLEX || {};
  const routes = cfg.routes || {};

  function placeholderImg() {
    const onDark = document.documentElement.getAttribute("data-theme") === "dark";
    const o = cfg.logos || {};
    return onDark ? o.qlexDark : o.qlexLight;
  }

  function money(cents) {
    const n = Number(cents);
    if (Number.isNaN(n)) return "";
    return "$" + (n / 100).toFixed(2);
  }

  function absUrl(url) {
    if (!url) return "";
    return String(url).indexOf("//") === 0 ? "https:" + url : url;
  }

  // ─── Splash ───

  const splashOverlay = document.getElementById("splashOverlay");
  const SMS_PROMPT_KEY = "qlex_sms_prompt";

  function smsPromptState() {
    try {
      return localStorage.getItem(SMS_PROMPT_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function setSmsPromptState(value) {
    try {
      localStorage.setItem(SMS_PROMPT_KEY, value);
    } catch (e) {
      /* ignore */
    }
  }

  function hideSmsPrompt() {
    document.querySelectorAll("[data-sms-prompt]").forEach((el) => {
      el.hidden = true;
    });
    const modal = document.getElementById("qlexSmsModal");
    if (modal) {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
    }
  }

  function showSmsPrompt(force) {
    if (!force && smsPromptState()) return;
    const modal = document.getElementById("qlexSmsModal");
    if (!modal || !modal.querySelector("[data-sms-prompt]")) return;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
  }

  function dismissSplash() {
    if (!splashOverlay || splashOverlay.classList.contains("splash--gone")) return;
    splashOverlay.classList.add("splash--gone");
    document.body.classList.remove("splash-open");
    splashOverlay.setAttribute("aria-hidden", "true");
    showSmsPrompt();
  }

  if (document.querySelector("[data-sms-joined]")) {
    if (splashOverlay) dismissSplash();
    else showSmsPrompt(true);
    setSmsPromptState("joined");
    setTimeout(hideSmsPrompt, 1400);
  } else if (smsPromptState()) {
    hideSmsPrompt();
  } else if (!splashOverlay && !document.body.classList.contains("game-body")) {
    showSmsPrompt();
  }

  document.getElementById("splashSmsSkip")?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSmsPromptState("skipped");
    hideSmsPrompt();
  });

  document.getElementById("qlexSmsModal")?.addEventListener("click", (e) => {
    if (e.target.id === "qlexSmsModal") {
      setSmsPromptState("skipped");
      hideSmsPrompt();
    }
  });

  if (splashOverlay) {
    document.body.classList.add("splash-open");
    document.getElementById("splashEnterBtn")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      dismissSplash();
    });
  }

  // ─── Shop grid ───

  const productGrid = document.getElementById("productGrid");
  const sideNav = document.getElementById("sideNav");
  const collectionTitle = document.querySelector(".collection-title");
  const productCountEl = document.getElementById("productCount");
  const searchInput = document.querySelector(".search-bar-input");
  const searchForm = document.querySelector(".search-bar");
  const sidebar = document.getElementById("sidebar");
  const mobileMenuToggle = document.getElementById("mobileMenuToggle");

  function visibleCards() {
    if (!productGrid) return [];
    return [...productGrid.querySelectorAll(".product")].filter((c) => c.style.display !== "none");
  }

  function updateCount() {
    if (productCountEl) productCountEl.textContent = visibleCards().length;
  }

  function buildSidebar() {
    if (!sideNav || !productGrid) return;
    const types = [
      ...new Set(
        [...productGrid.querySelectorAll(".product")]
          .map((c) => c.dataset.productType)
          .filter(Boolean)
      ),
    ];
    let html = '<ul><li><a href="#" class="nav-link active" data-filter="all">ALL</a></li>';
    types.forEach((t) => {
      html += `<li><a href="#" class="nav-link" data-filter="${t.replace(/"/g, "&quot;")}">${t.toUpperCase()}</a></li>`;
    });
    html += "</ul>";
    sideNav.innerHTML = html;
    sideNav.querySelectorAll(".nav-link").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const filter = link.dataset.filter;
        sideNav.querySelectorAll(".nav-link").forEach((l) => l.classList.remove("active"));
        link.classList.add("active");
        if (collectionTitle && filter === "all") collectionTitle.textContent = "ALL";
        else if (collectionTitle) collectionTitle.textContent = link.textContent;
        productGrid.querySelectorAll(".product").forEach((card) => {
          const match = filter === "all" || card.dataset.productType === filter;
          card.style.display = match ? "" : "none";
        });
        if (searchInput) searchInput.dispatchEvent(new Event("input"));
        else updateCount();
        sidebar?.classList.remove("open");
      });
    });
    updateCount();
  }

  if (productGrid) {
    buildSidebar();
    productGrid.querySelectorAll(".product-image-wrap").forEach((a) => {
      a.addEventListener("click", (e) => {
        const card = a.closest(".product");
        const handle = card?.dataset.productHandle;
        if (!handle || !document.getElementById("pdpModal")) return;
        e.preventDefault();
        openProductByHandle(handle);
      });
    });
  }

  if (searchInput && productGrid) {
    searchInput.addEventListener("input", () => {
      const q = searchInput.value.toLowerCase().trim();
      const active = sideNav?.querySelector(".nav-link.active")?.dataset.filter || "all";
      productGrid.querySelectorAll(".product").forEach((card) => {
        const title = card.querySelector(".product-title")?.textContent.toLowerCase() || "";
        const typeOk = active === "all" || card.dataset.productType === active;
        card.style.display = typeOk && (q === "" || title.includes(q)) ? "" : "none";
      });
      updateCount();
    });
    searchForm?.addEventListener("submit", (e) => {
      if (document.body.classList.contains("index")) {
        e.preventDefault();
      }
    });
  }

  // ─── Product detail (Ajax product + Liquid product.json) ───

  const pdpOverlay = document.getElementById("pdpOverlay");
  const pdpModal = document.getElementById("pdpModal");
  const pdpClose = document.getElementById("pdpClose");

  let pdpSelectedOptions = {};
  let pdpCurrentProduct = null;
  let pdpMainImageIdx = 0;

  const PDP_SIZE_VALUE_RE = /^(xxs|2xs|xs|s|small|m|medium|l|large|xl|xxl|2xl|xxxl|3xl|one[\s-]?size|os|m\/l|l\/xl)$/i;
  const PDP_SIZE_ORDER = [
    "2xs", "xxs", "xs", "s", "small", "m", "medium", "l", "large", "xl", "xxl", "2xl", "xxxl", "3xl",
  ];

  function isLikelySizeOnlyOption(opt) {
    if (!opt?.values?.length) return false;
    return opt.values.every((v) => PDP_SIZE_VALUE_RE.test(String(v).trim()));
  }

  function productOptions(p) {
    const opts = p.options || [];
    if (!opts.length) return [];
    if (typeof opts[0] === "string") {
      return opts.map((name, i) => {
        const values = [...new Set(p.variants.map((v) => v["option" + (i + 1)]).filter((v) => v && v !== "Default Title"))];
        return { name, values };
      }).filter((o) => o.values.length);
    }
    return opts
      .map((o) => ({ name: o.name, values: o.values || [] }))
      .filter((o) => !(o.values.length <= 1 && o.values[0] === "Default Title"));
  }

  function productImages(p) {
    if (!p.images || !p.images.length) return [];
    return p.images.map((img) => {
      if (typeof img === "string") return { url: absUrl(img), alt: p.title };
      const src = img.src || img.url || "";
      return { url: absUrl(src), alt: img.alt || p.title };
    }).filter((n) => n.url);
  }

  function variantImage(v, fallback) {
    const src = v.featured_image?.src || v.featured_image?.url;
    return src ? absUrl(src) : fallback;
  }

  function variantSelected(v, options) {
    return options.map((opt, i) => ({
      name: opt.name,
      value: (v.options && v.options[i]) || v["option" + (i + 1)],
    }));
  }

  function getPdpColorOption(options) {
    const o = options.find((x) => x.name.toLowerCase() === "color" || x.name.toLowerCase() === "colour");
    if (!o || o.values.length <= 1) return null;
    if (isLikelySizeOnlyOption(o)) return null;
    return o;
  }

  function sortSizeLikeValues(values) {
    if (!values.length || !values.every((v) => PDP_SIZE_VALUE_RE.test(String(v).trim()))) return values;
    const rank = (v) => {
      const i = PDP_SIZE_ORDER.indexOf(String(v).trim().toLowerCase());
      return i === -1 ? 999 : i;
    };
    return [...values].sort((a, b) => rank(a) - rank(b));
  }

  function getPdpOptionLabel(opt, mergedValues) {
    const name = String(opt.name || "").trim();
    if (PDP_SIZE_VALUE_RE.test(name)) {
      const inValues = mergedValues.some((v) => String(v).toLowerCase() === name.toLowerCase());
      if (!inValues) return "Size";
    }
    return opt.name;
  }

  function escapeHtmlAttr(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;");
  }

  function findMatchingVariant(product, options) {
    const required = options.filter((o) => !(o.values.length === 1 && o.values[0] === "Default Title"));
    if (required.length === 0) return product.variants[0] || null;
    if (!required.every((o) => pdpSelectedOptions[o.name])) return null;
    return product.variants.find((v) =>
      variantSelected(v, options).every((so) => !so.value || pdpSelectedOptions[so.name] === so.value)
    ) || null;
  }

  function renderPdpHtml(product) {
    const images = productImages(product);
    const options = productOptions(product);
    const variants = product.variants || [];
    const price = money(product.price_min != null ? product.price_min : product.price);
    const colorOption = getPdpColorOption(options);

    let colorThumbsHtml = "";
    if (colorOption && colorOption.values.length > 1) {
      colorThumbsHtml = `<div class="pdp-option-group">
        <div class="pdp-option-label">${escapeHtmlAttr(colorOption.name).toUpperCase()}</div>
        <div class="pdp-color-thumbs">`;
      colorOption.values.forEach((color) => {
        const matchingVariant = variants.find((v) =>
          variantSelected(v, options).some((o) => o.name === colorOption.name && o.value === color)
        );
        const thumb = variantImage(matchingVariant, images[0]?.url) || placeholderImg();
        colorThumbsHtml += `<button type="button" class="pdp-color-thumb" data-option-name="${escapeHtmlAttr(colorOption.name)}" data-option-value="${escapeHtmlAttr(color)}" title="${escapeHtmlAttr(color)}">
          <img src="${thumb}" alt="${escapeHtmlAttr(color)}">
        </button>`;
      });
      colorThumbsHtml += `</div></div>`;
    }

    let optionsHtml = "";
    options.forEach((opt) => {
      if (colorOption && opt.name === colorOption.name) return;
      if (opt.values.length <= 1 && opt.values[0] === "Default Title") return;
      const merged = sortSizeLikeValues(opt.values);
      const label = getPdpOptionLabel(opt, merged);
      optionsHtml += `<div class="pdp-option-group">
        <div class="pdp-option-label">${escapeHtmlAttr(label).toUpperCase()}</div>
        <div class="pdp-size-options">`;
      merged.forEach((val) => {
        optionsHtml += `<button type="button" class="pdp-size-btn" data-option-name="${escapeHtmlAttr(opt.name)}" data-option-value="${escapeHtmlAttr(val)}">${escapeHtmlAttr(val)}</button>`;
      });
      optionsHtml += `</div></div>`;
    });

    let thumbsHtml = "";
    if (images.length > 1) {
      thumbsHtml = `<div class="pdp-thumbs">`;
      images.forEach((img, i) => {
        thumbsHtml += `<button type="button" class="pdp-thumb${i === 0 ? " active" : ""}" data-idx="${i}">
          <img src="${img.url}" alt="${escapeHtmlAttr(img.alt || "")}">
        </button>`;
      });
      thumbsHtml += `</div>`;
    }

    const mainImg = images[0]?.url || placeholderImg();
    return `
      <div class="pdp-layout">
        <div class="pdp-gallery">
          <div class="pdp-main-image">
            <img id="pdpMainImg" src="${mainImg}" alt="${escapeHtmlAttr(product.title)}">
            ${images.length > 1 ? `<button type="button" class="pdp-nav pdp-nav-next" id="pdpNext">&#8250;</button>` : ""}
          </div>
          ${thumbsHtml}
        </div>
        <div class="pdp-info">
          <h1 class="pdp-title">${escapeHtmlAttr(product.title)}</h1>
          <div class="pdp-price" id="pdpPrice">${price}</div>
          ${colorThumbsHtml}
          ${optionsHtml}
          <button type="button" class="pdp-add-btn" id="pdpAddBtn" ${!product.available ? "disabled" : ""}>
            ${product.available ? (options.length ? "SELECT SIZE" : "ADD TO CART") : "SOLD OUT"}
          </button>
          <div class="pdp-description">${product.description || ""}</div>
        </div>
      </div>`;
  }

  function bindPdpEvents(product) {
    const images = productImages(product);
    const options = productOptions(product);
    const variants = product.variants || [];

    document.querySelectorAll(".pdp-thumb").forEach((btn) => {
      btn.addEventListener("click", () => {
        pdpMainImageIdx = parseInt(btn.dataset.idx, 10);
        const img = document.getElementById("pdpMainImg");
        if (img && images[pdpMainImageIdx]) img.src = images[pdpMainImageIdx].url;
        document.querySelectorAll(".pdp-thumb").forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
      });
    });

    document.getElementById("pdpNext")?.addEventListener("click", () => {
      if (!images.length) return;
      pdpMainImageIdx = (pdpMainImageIdx + 1) % images.length;
      const img = document.getElementById("pdpMainImg");
      if (img) img.src = images[pdpMainImageIdx].url;
      document.querySelectorAll(".pdp-thumb").forEach((b) =>
        b.classList.toggle("active", parseInt(b.dataset.idx, 10) === pdpMainImageIdx)
      );
    });

    document.querySelectorAll(".pdp-color-thumb").forEach((btn) => {
      btn.addEventListener("click", () => {
        pdpSelectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
        document.querySelectorAll(`.pdp-color-thumb[data-option-name="${btn.dataset.optionName}"]`).forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        updatePdpVariant(product, options, variants);
      });
    });

    document.querySelectorAll(".pdp-size-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        pdpSelectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
        document.querySelectorAll(`.pdp-size-btn[data-option-name="${btn.dataset.optionName}"]`).forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        updatePdpVariant(product, options, variants);
      });
    });

    document.getElementById("pdpAddBtn")?.addEventListener("click", async (e) => {
      e.preventDefault();
      const matched = findMatchingVariant(product, options);
      if (!matched || !matched.available) return;
      const addBtn = document.getElementById("pdpAddBtn");
      addBtn.textContent = "ADDING...";
      addBtn.disabled = true;
      try {
        await addToCart(matched.id);
        closePdp();
        openCart();
      } catch (err) {
        console.error(err);
        addBtn.textContent = "ADD TO CART";
        addBtn.disabled = false;
      }
    });
  }

  function updatePdpVariant(product, options, variants) {
    const matched = findMatchingVariant(product, options);
    const addBtn = document.getElementById("pdpAddBtn");
    const priceEl = document.getElementById("pdpPrice");
    const hiddenId = document.getElementById("productVariantId");
    if (!addBtn) return;
    if (matched) {
      if (priceEl) priceEl.textContent = money(matched.price);
      if (hiddenId) hiddenId.value = matched.id;
      if (matched.available) {
        addBtn.textContent = "ADD TO CART";
        addBtn.disabled = false;
      } else {
        addBtn.textContent = "SOLD OUT";
        addBtn.disabled = true;
      }
      const src = variantImage(matched);
      if (src) {
        const img = document.getElementById("pdpMainImg");
        if (img) img.src = src;
      }
    } else {
      addBtn.textContent = "SELECT SIZE";
      addBtn.disabled = true;
    }

    document.querySelectorAll(".pdp-size-btn").forEach((btn) => {
      const testOptions = { ...pdpSelectedOptions, [btn.dataset.optionName]: btn.dataset.optionValue };
      const testMatch = variants.find((v) =>
        variantSelected(v, options).every((so) => !testOptions[so.name] || testOptions[so.name] === so.value)
      );
      btn.classList.toggle("unavailable", testMatch && !testMatch.available);
    });
  }

  async function openProductByHandle(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) {
      window.location.href = `/products/${handle}`;
      return;
    }
    const product = await res.json();
    openProductDetail(product, true);
  }

  function openProductDetail(product, asModal) {
    pdpCurrentProduct = product;
    pdpSelectedOptions = {};
    pdpMainImageIdx = 0;
    const content = document.getElementById("pdpContent");
    if (!content) return;
    content.innerHTML = renderPdpHtml(product);
    bindPdpEvents(product);
    if (asModal && pdpModal) {
      pdpModal.classList.add("open");
      pdpOverlay?.classList.add("open");
      document.body.style.overflow = "hidden";
    }
  }

  function closePdp() {
    pdpModal?.classList.remove("open");
    pdpOverlay?.classList.remove("open");
    document.body.style.overflow = "";
    pdpCurrentProduct = null;
  }

  pdpClose?.addEventListener("click", closePdp);
  pdpOverlay?.addEventListener("click", closePdp);

  const productJsonEl = document.getElementById("ProductJson");
  if (productJsonEl) {
    try {
      const product = JSON.parse(productJsonEl.textContent);
      document.getElementById("product-form")?.addEventListener("submit", (e) => e.preventDefault());
      openProductDetail(product, false);
    } catch (err) {
      console.error(err);
    }
  }

  // ─── Cart (Ajax Cart API) ───

  const cartToggle = document.getElementById("cartToggle");
  const cartOverlay = document.getElementById("cartOverlay");
  const cartDrawer = document.getElementById("cartDrawer");
  const cartClose = document.getElementById("cartClose");
  const cartCount = document.getElementById("cartCount");
  const cartItemsLabel = document.getElementById("cartItemsLabel");
  const cartDrawerBody = document.getElementById("cartDrawerBody");
  const cartDrawerFooter = document.getElementById("cartDrawerFooter");
  const cartSubtotal = document.getElementById("cartSubtotal");
  const checkoutBtn = document.getElementById("checkoutBtn");

  async function cartJson(path, options) {
    const res = await fetch(path, {
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      ...options,
    });
    if (!res.ok) throw new Error("Cart request failed");
    return res.json();
  }

  async function fetchCart() {
    return cartJson((routes.cart || "/cart") + ".js");
  }

  async function addToCart(variantId) {
    await cartJson((routes.cartAdd || "/cart/add") + ".js", {
      method: "POST",
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    const cart = await fetchCart();
    syncCartUI(cart);
  }

  async function changeLine(key, quantity) {
    const cart = await cartJson((routes.cartChange || "/cart/change") + ".js", {
      method: "POST",
      body: JSON.stringify({ id: key, quantity }),
    });
    syncCartUI(cart);
  }

  function syncCartUI(cart) {
    const items = cart.items || [];
    const totalQty = cart.item_count || 0;
    if (cartCount) cartCount.textContent = totalQty;
    if (cartItemsLabel) cartItemsLabel.textContent = totalQty + " item" + (totalQty !== 1 ? "s" : "");

    if (!cartDrawerBody) return;

    if (items.length === 0) {
      cartDrawerBody.innerHTML = '<p class="cart-drawer-empty">Your cart is empty</p>';
      if (cartDrawerFooter) cartDrawerFooter.hidden = true;
      return;
    }

    if (cartDrawerFooter) cartDrawerFooter.hidden = false;
    if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
    if (checkoutBtn) checkoutBtn.setAttribute("href", routes.checkout || "/checkout");

    cartDrawerBody.innerHTML = items
      .map((item) => {
        const imgUrl = absUrl(item.image) || placeholderImg();
        return `
        <div class="cart-item">
          <div class="cart-item-thumb"><img src="${imgUrl}" alt=""></div>
          <div class="cart-item-details">
            <div class="cart-item-name">${escapeHtmlAttr(item.product_title)}</div>
            <div class="cart-item-price">${money(item.final_price != null ? item.final_price : item.price)}</div>
            <div class="cart-item-qty">
              <button type="button" data-line-key="${escapeHtmlAttr(item.key)}" data-action="dec">&minus;</button>
              <span>${item.quantity}</span>
              <button type="button" data-line-key="${escapeHtmlAttr(item.key)}" data-action="inc">+</button>
            </div>
          </div>
          <button type="button" class="cart-item-remove" data-line-key="${escapeHtmlAttr(item.key)}">&times;</button>
        </div>`;
      })
      .join("");

    cartDrawerBody.querySelectorAll("[data-action]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const key = btn.dataset.lineKey;
        const item = items.find((l) => l.key === key);
        if (!item) return;
        if (btn.dataset.action === "inc") changeLine(key, item.quantity + 1);
        else changeLine(key, item.quantity - 1);
      });
    });
    cartDrawerBody.querySelectorAll(".cart-item-remove").forEach((btn) => {
      btn.addEventListener("click", () => changeLine(btn.dataset.lineKey, 0));
    });
  }

  function openCart(e) {
    if (e) e.preventDefault();
    cartDrawer?.classList.add("open");
    cartOverlay?.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeCart() {
    cartDrawer?.classList.remove("open");
    cartOverlay?.classList.remove("open");
    document.body.style.overflow = "";
  }

  cartToggle?.addEventListener("click", openCart);
  cartClose?.addEventListener("click", closeCart);
  cartOverlay?.addEventListener("click", closeCart);

  fetchCart().then(syncCartUI).catch(() => {});

  // ─── Mobile sidebar ───

  mobileMenuToggle?.addEventListener("click", () => sidebar?.classList.toggle("open"));
  document.addEventListener("click", (e) => {
    if (sidebar?.classList.contains("open") && !sidebar.contains(e.target) && e.target !== mobileMenuToggle && !mobileMenuToggle?.contains(e.target)) {
      sidebar.classList.remove("open");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (splashOverlay && !splashOverlay.classList.contains("splash--gone")) {
      return;
    }
    if (e.key === "Escape") {
      const smsModal = document.getElementById("qlexSmsModal");
      if (smsModal && !smsModal.hidden) {
        setSmsPromptState("skipped");
        hideSmsPrompt();
        return;
      }
      closePdp();
      closeCart();
      sidebar?.classList.remove("open");
    }
  });
});
